export default __webpack_public_path__ + "static/media/formulas.9793f860.svg";